import Tasks from 'APP/Tasks';
import { IUserGroupRoleChanged } from 'APP/model/counter/counterModel.types';
import bus from 'APP/packages/bus';

import { GroupsEvent } from '../GroupsEvent';

export class UserRoleWereUpdated extends GroupsEvent<IUserGroupRoleChanged[]> {
  process(): void {
    (this.eventPayload || []).forEach((roleChanged): void => {
      bus.group.broadcastParticipantsChanges(roleChanged.groupId);
      Tasks.group.updateUserGroupRole(roleChanged);
    });
  }
}
